module.exports = __webpack_public_path__ + "static/img/303_TO8_2279.68410c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/303_TO8_2279.jpg
// module id = sjFy
// module chunks = 0